import React from "react";
import Post from "./Post";
import AppelAction from "../../components/AppelAction";   

const Article = ({ useId = false }) => {
    return (
        <>
            <Post useId={useId} />
            <AppelAction className="section-border-top" />
        </>
    );
};

export default Article;
